import React, {useEffect, useState} from 'react';
import {Col, Form, Image, Row} from "react-bootstrap";
import {delCMFWFloor, delCMFWList, postCMFWFloor, putCMFWFloor} from "../../api/apiClient";
import Swal from "sweetalert2";
import Button from "react-bootstrap/Button";

const FcltyFloorAdd = ({
                         propFcltyID = undefined,
                         propIsReg = true,
                         propDtlNm,
                         propDtlNo,
                         hClose,
                       }) => {

  useEffect(() => {
    console.log(propIsReg, propDtlNm, propDtlNo)
    if (propIsReg == true) {
      setFloorAddInputs((prevState) => ({
        ...prevState,
        fcltyNo: propFcltyID,
      }));
    } else {
      setFloorAddInputs((prevState) => ({
        ...prevState,
        fcltyNo: propFcltyID,
        fcltyDtlNm: propDtlNm,
        fcltyDtlNo: propDtlNo
      }));
    }

    console.log(floorAddInputs)
  }, [propFcltyID]);

  const [floorAddInputs, setFloorAddInputs] = useState({
    fcltyNo: propFcltyID, // 시설관리NO
    fcltyDtlNm: '',  // 시설상세위치명(층명)
    file: '', // 도면
    // fcltyDtlNo: '', // 층관리NO
    // fcltyDtlSn: '', // 정렬순서
  });

  const encodeFileToBase64 = (fileBlob) => {
    const reader = new FileReader();
    reader.readAsDataURL(fileBlob);
    return new Promise((resolve) => {
      reader.onload = () => {
        // setImageSrc(reader.result);
        setFloorAddInputs((prevState) => ({
          ...prevState,
          file: reader.result,
          filepath: fileBlob
        }));
        resolve();
      };
    });
  };

  const onSubmit = (e) => {
    e.preventDefault();
    // console.log(floorAddInputs);
    const isEmpty = (object) => !Object.values(object).every(x => (x !== null && x !== ''));
    // console.log(isEmpty(floorAddInputs));
    // if (isEmpty(floorAddInputs)) {
    //     console.log('빈값이 있습니다.');
    //     if (floorAddInputs.fcltyNo === undefined) {
    //         alert('시설정보가 없습니다.');
    //     }
    // } else
    {
      console.log('빈값이 없습니다.');
      if (propIsReg) {
        postCMFWFloor(floorAddInputs)
            .then((res) => {
              console.log(res);
              if (res.data.status === 200) {
                // alert('층이 등록되었습니다.');
                Swal.fire(
                    '정상적으로 처리 되었습니다!',
                    '',
                    'success'
                );
                hClose();
              } else {
                // alert('층 등록에 실패했습니다.');
                Swal.fire(
                    `층 등록에 실패했습니다.`,
                    '',
                    'error'
                );
              }
            });
      } else {
        putCMFWFloor(floorAddInputs)
            .then((res) => {
              console.log(res);
              if (res.data.status === 200) {
                // alert('층이 등록되었습니다.');
                Swal.fire(
                    '정상적으로 처리 되었습니다!',
                    '',
                    'success'
                );
                hClose();
              } else {
                // alert('층 등록에 실패했습니다.');
                Swal.fire(
                    `층 수정에 실패했습니다.`,
                    '',
                    'error'
                );
              }
            });
      }
    }
  };

  const onDelete = () => {
    Swal.fire({
      title: `삭제하시겠습니까?`,
      text: `[${floorAddInputs.fcltyDtlNm}] 층을 삭제합니다.`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: '확인',
      cancelButtonText: '취소'
    }).then((result) => {
      if (result.isConfirmed) {
        delCMFWFloor(floorAddInputs).then(
            (res => {
              // return code 확인 필요
              console.log(res);

              Swal.fire(
                  '삭제되었습니다!',
                  'Your file has been deleted.',
                  'success'
              );
              hClose();
            })
        )
      }
    })

  }

  return (
      <>
        <Form
            className={'fclty-floor-add-form py-3'}
            id={'FcltyFloorAddForm'}
            onSubmit={onSubmit}
        >
          <Row>
            <Col md={12}>
              <Row className={"justify-content-center"}>
                <Col md={10}>
                  <Form.Group as={Row} controlId="floorName">
                    <Form.Label column md={3} className={'label text-center fw-bold'}>
                      <span className={"text-danger"}>* </span> 이름
                    </Form.Label>
                    <Col md={9} className={''}>
                      <Form.Control
                          type='text'
                          className={'input text-white'}
                          onChange={(e) => {
                            setFloorAddInputs((prevState) => ({
                              ...prevState,
                              fcltyDtlNm: e.target.value,
                            }));
                          }}
                          value={floorAddInputs.fcltyDtlNm}
                      />
                    </Col>
                  </Form.Group>
                </Col>
              </Row>
              <Row className={"justify-content-center mt-3"}>
                <Col md={10}>
                  <Form.Group as={Row} controlId="image">
                    <Form.Label column md={3} className={'label text-center fw-bold'}>
                      <span className={"text-danger"}>* </span> 도면
                    </Form.Label>
                    <Col md={9}>
                      <Form.Control
                          className={"input text-white"}
                          type="file"
                          accept='image/*'
                          onChange={(e) => {
                            console.log(e);
                            // setFloorAddInputs((prevState) => ({
                            //   ...prevState,
                            //   filepath: e.target.value
                            // }))
                            encodeFileToBase64(e.target.files[0]);
                          }}
                      />
                    </Col>
                  </Form.Group>
                </Col>
              </Row>

              <Row className={"justify-content-center mt-3"}>
                <Col md={10} className={'text-center'}>
                  {floorAddInputs.file &&
                      <Image src={floorAddInputs.file} className={"img-fluid"}/>}
                </Col>
              </Row>

              <hr/>

              <Row className={"justify-content-center mt-4"}>
                {propIsReg ?
                    '' :
                    <Col md={2}>
                      <Button type="button" className="btn-danger w-75"
                              onClick={onDelete}
                      >
                        삭제
                      </Button>
                    </Col>
                }
                <Col md={2}>
                  <button type="submit" className="submit-btn btn btn-primary w-75">
                    저장
                  </button>
                </Col>
                <Col md={2}>
                  <button type="button" className="cancel-btn btn btn-secondary w-75"
                          onClick={hClose}
                  >
                    취소
                  </button>
                </Col>
              </Row>
            </Col>
          </Row>
        </Form>

      </>
  );
};

export default FcltyFloorAdd;
